export const safeLowerCase = (string: string) => string && string.toLowerCase();

export const safeUpperCase = (string: string) => string && string.toUpperCase();

export const stringEqualsInsensitive = (string1: string, string2: string) =>
  safeLowerCase(string1) === safeLowerCase(string2);

export const stringEquals = (string1: string, string2: string) => string1 === string2;

export const slugify = (text: string): string =>
  text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');

// Capitalize FIRST letter of EACH word
export const capitalize = (text: string): string =>
  text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

// Taken from lodash. Code is based on loose comparison
export const getTag = (value: any): string => {
  // eslint-disable-next-line no-eq-null, eqeqeq
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]';
  }
  return Object.prototype.toString.call(value);
};

export const isString = (value: any): boolean => {
  const type = typeof value;

  return (
    type === 'string' ||
    // eslint-disable-next-line no-eq-null, eqeqeq
    (type === 'object' && value != null && !Array.isArray(value) && getTag(value) == '[object String]')
  );
};

/**
 * Capitalize first letter
 * @param word string to capitalize
 */
const capitalizeFirstChar = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

/**
 * Return truncated version or the name
 * eg. Kimi => K.
 * @param name the string to truncate
 */
export const truncateNameWithDot = (name: string): string => (name ? `${name.charAt(0).toUpperCase()}.` : '');

/**
 * Uppercase first char of each word in a text
 * @param text string to uppercaseFirstLetterString
 */
export const uppercaseFirstCharInText = (text: string): string =>
  text
    .toLowerCase()
    .split(' ')
    .map((word: string) => capitalizeFirstChar(word))
    .join(' ');

/**
 * Remove Tailing slash from a string
 * @param pathname string url
 * @returns string url without tailingSlash
 */
export const removeTrailingSlash = (pathname: string): string => pathname.replace(/(.*)\/$/, '$1');
